// Aggregate returned stock units into one row per (product, damaged), preserving the
// product total, with a per-lot breakdown so each lot (and its count) can be shown as a
// chip without splitting the list. Grouping per-lot instead would drop the product total
// and interleave one row per lot, a regression for the common "how many came back?" read.
// Each lot entry keeps the serializer's fields (unique_code, expiration_date, status) plus
// a running count. Used by the returns detail (ShowReturnContainer) for both the regular
// and the bulk-replenishment lists, which aggregate identically.
export const aggregateReturnedUnits = (units) => {
  const rows = []
  ;(units || []).forEach((stock) => {
    const damaged = stock.status === "DAMAGED"
    let row = rows.find((r) => r.product.id === stock.product.id && r.damaged === damaged)
    if (!row) {
      row = { product: { ...stock.product }, quantity: 0, damaged, lots: [] }
      rows.push(row)
    }
    row.quantity += 1
    if (stock.lot) {
      const lotEntry = row.lots.find((l) => l.id === stock.lot.id)
      if (lotEntry) lotEntry.count += 1
      else row.lots.push({ ...stock.lot, count: 1 })
    }
  })
  return rows
}
